import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { AppBar, APP } from "../../components/mobileUi";
import {
  DesktopBack,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../../components/desktopUi";
import { getCustomerByIdApi } from "../../api/finance.customer.api";
import { buildCustomerAddress } from "../../utils/financeFormat";
import { EMP_BASE_PATH } from "../../config";

const BORDER = "#DCE1EA";
const TEXT = "#08142D";
const MUTED = "#94A3B8";

const Row = ({ label, value, last }) => (
  <Flex justify="space-between" align="flex-start" gap="16px" py="12px" borderBottom={last ? "none" : "0.5px solid #EEF1F6"}>
    <Text fontSize="14px" color={MUTED} flexShrink={0} flex="0 0 40%">{label}</Text>
    <Text fontSize="14px" fontWeight={600} color={TEXT} textAlign="right" flex="1">{value || "-"}</Text>
  </Flex>
);

const CustomerDetail = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getCustomerByIdApi(id)
      .then((d) => setData(d))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [id]);

  const rows = data
    ? data.isBusiness
      ? [
          { label: "Người đại diện", value: data.representativeName || data.contactName },
          { label: "Mã số thuế", value: data.businessTaxCode },
          { label: "Số điện thoại", value: data.phone },
          { label: "Email", value: data.email },
          { label: "Địa chỉ", value: data.businessAddress || data.businessLocationAddress },
        ]
      : [
          { label: "Ngày sinh", value: data.dateOfBirth },
          { label: Number(data.identityNumber) === 2 ? "Số hộ chiếu" : "Số CCCD/CMND", value: data.identificationNumber },
          { label: "Số điện thoại", value: data.phone },
          { label: "Email", value: data.email },
          { label: "Địa chỉ", value: buildCustomerAddress(data) },
        ]
    : [];

  const pageBody = (
    <>

      <Box px="16px" pt="16px">
        {loading ? (
          <Flex justify="center" py="60px"><Spinner color={APP.primary200} /></Flex>
        ) : error || !data ? (
          <Flex justify="center" py="60px"><Text fontSize="14px" color={MUTED}>Không tìm thấy khách hàng</Text></Flex>
        ) : (
          <Box>
            <Text fontSize="18px" fontWeight={600} color={TEXT}>{data.name || "-"}</Text>
            <Flex gap="8px" mt="8px" flexWrap="wrap">
              <Box bg={data.customerType?.color || "#E9FFF4"} borderRadius="8px" px="12px" py="4px">
                <Text fontSize="11px" fontWeight={600} color="#0BA859">{data.customerType?.name?.toUpperCase() || "KHÁCH HÀNG"}</Text>
              </Box>
              <Box bg={data.isBusiness ? "#EEF2FF" : "#FFF7ED"} borderRadius="8px" px="12px" py="4px">
                <Text fontSize="11px" fontWeight={600} color={data.isBusiness ? "#4338CA" : "#C2410C"}>{data.isBusiness ? "DOANH NGHIỆP" : "CÁ NHÂN"}</Text>
              </Box>
            </Flex>

            <Box mt="12px" border="1px solid" borderColor={BORDER} borderRadius="12px" px="16px" py="4px">
              {rows.map((r, i) => (
                <Row key={r.label} label={r.label} value={r.value} last={i === rows.length - 1} />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </>
  );

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage title="Chi tiết khách hàng" right={<DesktopBack onClick={() => navigate(-1)} />}>
        <DesktopPanel p="0" pb="24px">
          {pageBody}
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto" bg="white" minH="100dvh">
      <AppBar title="Chi tiết khách hàng" onBack={() => navigate(`${EMP_BASE_PATH}/tai-chinh/khach-hang`)} />
      {pageBody}
    </Box>
  );
};

export default CustomerDetail;
